// extracted by mini-css-extract-plugin
module.exports = {"list":"SpacedList_list__nteGI","item":"SpacedList_item__331Ad"};